export const getFlyerId = (flyer) => flyer?.id;
export const getFlyerTitle = (flyer) => flyer?.title;
export const getFlyerCustomLabel = (flyer) => flyer?.extras?.promo_code;
export const doesFlyerCustomLabelMatch = (flyer, customLabel) =>
  customLabel && getFlyerCustomLabel(flyer) === customLabel;
export const isStoreAnnouncement = (flyer) =>
  flyer && flyer.type === 'click-out' && flyer.sub_type === 'store-announcement';
